import { JBASE_NAMES } from "./jbaseNames";

const abStyles = `
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 400; font-display: swap; src: url('/fonts/Barlow-Regular.woff2') format('woff2'); }
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 500; font-display: swap; src: url('/fonts/Barlow-Medium.woff2') format('woff2'); }
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 600; font-display: swap; src: url('/fonts/Barlow-SemiBold.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 400; font-display: swap; src: url('/fonts/BarlowCondensed-Regular.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 600; font-display: swap; src: url('/fonts/BarlowCondensed-SemiBold.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 700; font-display: swap; src: url('/fonts/BarlowCondensed-Bold.woff2') format('woff2'); }
.ab * { margin:0; padding:0; box-sizing:border-box; }
.ab { min-height:100vh; background:#f5f4f2; font-family:'Barlow',sans-serif; color:#1a1a2e; display:flex; flex-direction:column; align-items:center; padding:22px 18px 60px; }
.ab-top { width:100%; max-width:680px; display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; }
.ab-back { background:none; border:none; font-family:'Barlow Condensed',sans-serif; font-size:14px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:#999; cursor:pointer; padding:6px 4px; }
.ab-back:hover { color:#e7589b; }
.ab-title { font-family:'Barlow Condensed',sans-serif; font-weight:700; font-size:clamp(30px,8vw,46px); letter-spacing:2px; text-transform:uppercase; color:#e7589b; line-height:1; margin-bottom:4px; text-align:center; }
.ab-kicker { font-family:'Barlow Condensed',sans-serif; font-size:13px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:#999; text-align:center; margin-bottom:26px; }
.ab-body { width:100%; max-width:680px; }
.ab-body p { font-size:16px; line-height:1.65; margin-bottom:16px; color:#333; }
.ab-body p.lead { font-size:18px; color:#1a1a2e; }
.ab-body b { color:#e7589b; font-weight:600; }
.ab-roster-head { margin:34px 0 6px; text-align:center; }
.ab-roster-title { font-family:'Barlow Condensed',sans-serif; font-weight:700; font-size:22px; letter-spacing:2px; text-transform:uppercase; color:#1a1a2e; }
.ab-roster-note { font-family:'Barlow',sans-serif; font-size:13px; color:#999; margin-top:2px; }
.ab-roster { width:100%; max-width:680px; margin-top:18px; padding:20px; background:#fff; border:1px solid #e5e5e5; border-radius:10px; column-width:150px; column-gap:22px; }
.ab-roster .n { font-family:'Barlow Condensed',sans-serif; font-size:14px; font-weight:600; line-height:1.7; color:#333; break-inside:avoid; }
.ab-foot { width:100%; max-width:680px; margin-top:26px; display:flex; gap:14px; justify-content:center; }
.ab-btn { padding:11px 30px; font-family:'Barlow Condensed',sans-serif; font-size:15px; font-weight:700; letter-spacing:2px; text-transform:uppercase; border-radius:8px; cursor:pointer; transition:all .15s; }
.ab-btn.primary { background:#e7589b; color:#fff; border:none; }
.ab-btn.primary:hover { background:#d44d8b; transform:translateY(-2px); box-shadow:0 4px 16px rgba(231,88,155,0.35); }
.ab-btn.ghost { background:#fff; color:#666; border:1.5px solid #ddd; }
.ab-btn.ghost:hover { background:#f5f5f5; color:#333; }
`;

export default function About({ onExit, onPlay }) {
  return (
    <>
      <style>{abStyles}</style>
      <div className="ab">
        <div className="ab-top">
          <button className="ab-back" onClick={onExit}>← Home</button>
        </div>
        <div className="ab-title">The Lore</div>
        <div className="ab-kicker">Why the names sound almost right</div>

        <div className="ab-body">
          <p className="lead">
            In 1994, EA Sports released <b>MLBPA Baseball</b> for the Super NES, Sega Genesis, and Game Gear.
            Thanks to a license from the Major League Baseball Players Association, it could use real players and
            their 1993 stats — though not the team names, which would have needed a separate MLB license.
          </p>
          <p>
            When the game reached Japan as <b>Fighting Baseball</b>, that players' license didn't come with it.
            So the developers filled the rosters the hard way: they took real athletes — from Major League Baseball,
            and, oddly, the NHL — and changed a letter here and there. The result was a lineup of names that sound
            almost exactly like real American ballplayers, and not quite like anyone at all.
          </p>
          <p>
            No one is entirely sure who did it. EA told the writer who later popularized the list that no one left
            at the company would know, and the Japanese developer, Coconuts Japan, is long gone. Decades later the
            roster resurfaced online and went viral — Bobson Dugnutt, Sleve McDichael, Onson Sweemey and the rest —
            beloved precisely because the names feel accidental.
          </p>
          <p>
            Sometimes you need to generate a fake athlete. And to be a genuine ball knower, you need to be able to
            spot the fakes. That's <b>Buttfumbles</b> — a name generator built in the Fighting Baseball spirit, and
            a game to test the depths of your ball knowledge.
          </p>
        </div>

        <div className="ab-roster-head">
          <div className="ab-roster-title">The Fighting Baseball Roster</div>
          <div className="ab-roster-note">All {JBASE_NAMES.length} names, exactly as they appeared in the game.</div>
        </div>
        <div className="ab-roster">
          {JBASE_NAMES.map((n, i) => (
            <div className="n" key={i}>{n}</div>
          ))}
        </div>

        <div className="ab-foot">
          <button className="ab-btn primary" onClick={onPlay}>Play Starting Five</button>
          <button className="ab-btn ghost" onClick={onExit}>Back to Generator</button>
        </div>
      </div>
    </>
  );
}
